import { useContext } from 'react';

import type { Site } from '@/api/fe-api/domain/entities/site';

import { CommunicationCurrentSiteContext } from '../providers/current-site';

export function useCurrentSite(): Site | undefined {
  return useContext(CommunicationCurrentSiteContext);
}
